// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import toolkitConstants from "@toolkit/constants";
import overrideProps from "@toolkit/Framework/Common/Utilities/overrideProps";

export default overrideProps(toolkitConstants, {
    formField: {
        borderWidth: 1 /* Store Custom Code */,
    },
    // Store Custom Code
    label: {
        notAvailable: translate("N/A"),
    },
    ledger: {
        documentType: "LedgerDocumentType",
        status: "LedgerStatus",
    },
    pageType: {
        billingStatus: "BillingStatusPage",
    },
    productAttributes: {
        headDiameter: "Head Diameter",
        finish: "Finish",
        head: "Head",
        iconBadgeGauge: "icon_badge_gauge",
        length: "Length",
        point: "Point",
        thread: "Thread",
    },
    relatedProductType: {
        fasteners: "Fasteners",
    },
    widgetGroup: {
        billingStatus: "Billing Status" as any,
    },
});
